<span class="header">
    <app-signinbox class="header-left"></app-signinbox>
    <a class="header-title" [routerLink]="titleLink" [matTooltip]="titleTooltip" matTooltipPosition="below">
        <h1>Genealogy Cards</h1>
    </a>
    <!-- prawy naroznik: jezyk + konto; oba w jednym elemencie siatki -->
    <span class="header-right">
        <app-language-switcher></app-language-switcher>
        <app-settingsbox></app-settingsbox>
    </span>
</span>
